<script setup lang="ts"></script>

<template>
  <span class="loader"></span>
</template>

<style scoped lang="css">
.loader {
  width: 400px;
  height: 100%;
  background:
    linear-gradient(0.25turn, transparent, #fff, transparent),
    linear-gradient(var(--color-client-gray), var(--color-client-gray)),
    radial-gradient(
      38px circle at 19px 19px,
      var(--color-client-gray) 50%,
      transparent 51%
    ),
    linear-gradient(var(--color-client-gray), var(--color-client-gray));
  background-color: #fff;
  background-repeat: no-repeat;
  background-position:
    -400px 0,
    0 0,
    15px 140px,
    65px 145px;
  animation: loading 1.5s infinite;
}

@keyframes loading {
  to {
    background-position:
      400px 0,
      0 0,
      15px 140px,
      65px 145px;
  }
}
</style>
